import { SVGInterface } from "../../interface";

const MailOpen = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M20 22H4C2.89543 22 2 21.1046 2 20V9.049C2.03375 8.37786 2.39728 7.76686 2.971 7.417L10.971 2.61699C11.6041 2.23737 12.3949 2.23737 13.028 2.61699L21.028 7.417C21.6292 7.77977 21.9976 8.42984 22 9.132V20C22 21.1046 21.1046 22 20 22ZM4 9.868V20H20V9.868L12 15.201L4 9.868ZM12 4.332L5.316 8.342L12 12.798L18.683 8.342L12 4.332Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default MailOpen;
